export const normalizeInput = (value:any) => {
  if (!value) return value;

  const currentValue = value.replace(/[^\d]/g, '');
  const cvLength = currentValue.length;

  
  if (cvLength < 4) return currentValue;
  if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;

  
  return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;

};


export const isvalid_mdy = (s:any) => {
  var day, A= s.match(/[0-9][\d]*/g);
 
      A[0]-= 1;
      day= new Date(+A[2], A[0], +A[1]);
      if(day.getMonth()== A[0] && day.getDate()== A[1]) 
      {
        return true;
      } else {
        return false;
      }
}


export const normalizeUSDate = (value:any) => {   
  if (!value) return value;


  if (value.includes("/"))
  {
    return value;
  } else {

  
    const currentValue = value.replace(/[^\d]/g, '');

    const cvLength = currentValue.length;

    if (cvLength < 7) return currentValue;
    
    if (cvLength < 4) return `${currentValue.slice(0,2)}/${currentValue.slice(2)}`;
    
    const newdob = `${currentValue.slice(4, 6)}/${currentValue.slice(6,8)}/${currentValue.slice(0, 4)}`;
    
    const age = calculate_age(newdob);

    if (age > 13)
    {
      
        return `${currentValue.slice(4, 6)}/${currentValue.slice(6,8)}/${currentValue.slice(0, 4)}`;
      
      
    } else {
      return `${currentValue.slice(4, 6)}/${currentValue.slice(6,8)}/${currentValue.slice(0, 4)}`;
    }
  }
  
}


  export const normalizeDate = (value:any) => {   
  if (!value) return value;
  const currentValue = value.replace(/[^\d]/g, '');
  const cvLength = currentValue.length;

  if (cvLength < 4) return currentValue;
  if (cvLength < 7) return `${currentValue.slice(0, 2)}/${currentValue.slice(2)}`;
  const newdob = `${currentValue.slice(0, 2)}/${currentValue.slice(2, 4)}/${currentValue.slice(4, 8)}`;
 
  const age = calculate_age(newdob);
 
  if (age > 13)
  {
    
       return `${currentValue.slice(0, 2)}/${currentValue.slice(2, 4)}/${currentValue.slice(4, 8)}`;
  } else {
    return `${currentValue.slice(0, 2)}/${currentValue.slice(2, 4)}/${currentValue.slice(4, 8)}`;
  }
  
}




export const calculate_age = (dob:any) => {
  var today = new Date();
  var birthDate = new Date(dob);  // create a date object directly from `dob1` argument
  var age_now = today.getFullYear() - birthDate.getFullYear();
  
  var m = today.getMonth() - birthDate.getMonth();
  
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
  {
      age_now--;
  }
  if (isNaN(age_now))
  {
   return 0;
  } else {
    return age_now;
  }
 
}